import { useRef, useState } from 'react';
import GiftCard from './GiftCard';
import { GiftItem } from '../../types/gifts';

interface GiftTimelineProps {
    items: GiftItem[];
    claimingId: string | null;
    onClaim: (item: GiftItem) => void;
}

const GiftTimeline = ({ items, claimingId, onClaim }: GiftTimelineProps) => {
    const trackRef = useRef<HTMLDivElement>(null);
    const [activeIndex, setActiveIndex] = useState(0);

    // The active dot follows the card nearest the scroll offset. Card width + gap is read live from
    // the DOM so the dots stay right whatever the card sizing resolves to.
    const handleScroll = () => {
        const track = trackRef.current;
        if (!track) return;

        const first = track.firstElementChild as HTMLElement | null;
        if (!first) return;

        const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        const step = first.offsetWidth + gap;

        if (step <= 0) return;

        const index = Math.round(track.scrollLeft / step);
        setActiveIndex(Math.max(0, Math.min(index, items.length - 1)));
    };

    if (items.length === 0) {
        return <div className="gift-timeline__empty">Sovg'alar hali qo'shilmagan</div>;
    }

    return (
        <div className="gift-timeline-wrap">
            <div className="gift-timeline" ref={trackRef} onScroll={handleScroll}>
                {items.map((item) => (
                    <GiftCard key={item.id} item={item} claiming={claimingId === item.id} onClaim={onClaim} />
                ))}
            </div>
            {items.length > 1 && (
                <div className="gift-dots">
                    {items.map((item, index) => (
                        <span key={item.id} className={`gift-dot${index === activeIndex ? ' is-active' : ''}`} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default GiftTimeline;
